import React, { useMemo } from "react";
import { motion } from "framer-motion";
import { STORE_OPEN, fmt } from "@/lib/storeConfig";

export const ProductCard = ({ p, i, onClick }) => {
  const label = useMemo(
    () => [p.drop, p.category].filter((v, idx, a) => a.findIndex((x) => x.toLowerCase() === v.toLowerCase()) === idx).join(" · "),
    [p.drop, p.category]
  );
  return (
    <motion.button
      data-testid={`merch-card-${p.id}`}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
      onClick={onClick}
      className="group text-left bg-[#0d0d0d] border border-white/8 hover:border-[#D4AF37]/50 transition-all"
    >
      <div className="relative aspect-square overflow-hidden bg-black">
        {p.premium && (
          <span className="absolute top-3 left-3 z-10 text-[9px] uppercase tracking-[0.3em] font-semibold text-black bg-[#D4AF37] px-2.5 py-1">
            Premium
          </span>
        )}
        <img
          src={p.img}
          alt={p.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />
      </div>
      <div className="p-4 sm:p-5">
        <p className="text-[9px] uppercase tracking-[0.3em] text-[#D4AF37]/80">{label}</p>
        <h3 className="font-display text-lg sm:text-xl text-white mt-2 leading-tight">{p.name}</h3>
        <p className="text-sm text-white/60 mt-2" data-testid={`merch-price-${p.id}`}>
          {fmt(p.price)}
          {!STORE_OPEN && <span className="ml-2 text-[9px] uppercase tracking-[0.25em] text-[#D4AF37]/90">· Coming Soon</span>}
        </p>
      </div>
    </motion.button>
  );
};
